import * as Sentry from '@sentry/nextjs'

export const generateTraceId = () => Math.random().toString(36).substr(2, 9)

export default Sentry
